"use client";

type PersistorLike = { flush: () => Promise<void> };

let persistorRef: PersistorLike | undefined;

export function registerReduxPersistor(persistor: PersistorLike | undefined) {
  persistorRef = persistor;
}

export function flushReduxPersist() {
  void persistorRef?.flush();
}
